import { MenuItem } from '@ovComponents/2-component/menuItem/menuItem';
import { SelectField } from '@ovComponents/2-component/selectField/selectField';
import { useTranslation } from 'react-i18next';
import {
  MODEL_PORTFOLIO_GROUP_BY,
  type ModelPortfolioGroupBy,
} from '../createModelPortfolio/modelPortfolioGroupBy';

export type HouseholdIpsGroupBySelectProps = {
  value: ModelPortfolioGroupBy;
  onChange: (groupBy: ModelPortfolioGroupBy) => void;
  disabled?: boolean;
  testId: string;
};

/**
 * Which asset class level the actual weights are totalled against. It says
 * nothing about the IPS itself, so it never joins the values the step hands on.
 */
export const HouseholdIpsGroupBySelect = ({
  value,
  onChange,
  disabled = false,
  testId,
}: HouseholdIpsGroupBySelectProps) => {
  const { t } = useTranslation(['client', 'components']);

  return (
    <SelectField
      testId={testId}
      label={t('client:groupBy')}
      value={value}
      onChange={(event: React.ChangeEvent<{ value: unknown }>) =>
        onChange(event.target.value as ModelPortfolioGroupBy)
      }
      disabled={disabled}
      fullWidth
    >
      <MenuItem value={MODEL_PORTFOLIO_GROUP_BY.PRIMARY}>
        {t('components:productShelf.exportHeaders.primaryAssetClass')}
      </MenuItem>
      <MenuItem value={MODEL_PORTFOLIO_GROUP_BY.SECONDARY}>
        {t('components:productShelf.exportHeaders.secondaryAssetClass')}
      </MenuItem>
    </SelectField>
  );
};

export default HouseholdIpsGroupBySelect;
